import {SvgInjector}      from './modules/svgInjector';
import {Parallax}         from './modules/parallax';
import {ImagePopUp}       from './modules/imagePopUp';
import {Carousels}        from './modules/carousels';
import {MiniGallery}      from './modules/miniGallery';
import {Cookies}          from './modules/cookies';
import {ScrollTo}         from './modules/scrollTo';
import {GoogleMaps}       from './modules/googleMaps';
import {Video}            from './modules/video';
import {Validator}        from './modules/validator';
import {SidePanel}        from './modules/sidePanel';
import {Visible}        from './modules/visible';
import {Switches}        from './modules/switches';
import {Countdown}        from './modules/countdown';
// import {Load}             from './modules/load';

var svgInjector       = new SvgInjector();
var parallax          = new Parallax();
var imagePopUp        = new ImagePopUp();
var carousels         = new Carousels();
var miniGallery       = new MiniGallery();
var cookies           = new Cookies();
var scrollTo          = new ScrollTo();
var googleMaps        = new GoogleMaps();
var video             = new Video();
var validator         = new Validator();
var sidePanel         = new SidePanel();
var visible         = new Visible();
var switches         = new Switches();
var countdown         = new Countdown();
// var load              = new Load();

class Main{
  constructor(node_env){
    this.node_env = node_env;
    this.sections = $('.cms-section');
}
  bootstrap(callback){
    var $sections = $(this.sections);
    this.modules($sections);
    this.responsiveModules($sections);
    callback();
  }

  modules($sections){
    parallax.init($sections);
    svgInjector.init();
    imagePopUp.init();
    carousels.init();
    miniGallery.init();
    cookies.init();
    scrollTo.init();
    googleMaps.init();
    video.init();
    validator.init();
    sidePanel.init();
    visible.init();
    switches.init();
    countdown.init();
    // load.init();
  }

  responsiveModules($sections){
    $(window).resize(function(){
      parallax.init($sections);
      carousels.init();
      miniGallery.init();
    });

    $(window).scroll(function(){
      $('.video-player').each(function(id, videoPlayer){
        if( $(videoPlayer).visible(true) ){
          video.play($(videoPlayer));
        }else{
          video.stop($(videoPlayer));
        }
      });
    });
  }
}


$(window).load(function(){
  var main = new Main('development');
  main.bootstrap(function(){
    $('#page-overlay').fadeOut(800);
  });
  $('.btn-mystic-2019').on('click', function() {
    $('.popup2020').fadeOut();
  });
});

var lazyLoadInstance = new LazyLoad({
    elements_selector: ".lazy"
});